import HttpClient from '../../gateway/HttpClient';
import { notUndefined } from '../../util/Assert';
import HttpMethod from '../../constant/HttpMethod';
import { RuleMethods } from '../../constant/MethodNames';
import { RuleJsonModel } from '../../domain/collection/rule/FlowDomains';
import RuleClient from './RuleClient';
import { query } from '@trlogic/client-js';
import { ActionType } from '../../constant/Constants';
import Query = query.Query;
import Filter = query.Filter;

class NestRuleClient implements RuleClient {
  private readonly httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    notUndefined(httpClient, 'Http client cannot be undefined');
    this.httpClient = httpClient;
  }

  public save(flow: RuleJsonModel): Promise<void> {
    const dto = { id: flow.name, object: flow };
    return this.httpClient.execute(HttpMethod.POST, RuleMethods.SAVE, dto);
  }

  public remove(name: string): Promise<void> {
    return this.httpClient.execute(HttpMethod.DELETE, `${RuleMethods.REMOVE}/${name}`);
  }

  public deploy(name: string): Promise<void> {
    return this.httpClient.execute(HttpMethod.POST, `${RuleMethods.DEPLOY}/${name}`);
  }

  public undeploy(name: string): Promise<void> {
    return this.httpClient.execute(HttpMethod.POST, `${RuleMethods.UNDEPLOY}/${name}`);
  }

  public isExist(name: string): Promise<boolean> {
    return this.httpClient.execute(HttpMethod.GET, `${RuleMethods.EXIST}/${name}`);
  }

  public count(query: Query): Promise<number> {
    return this.httpClient.execute(HttpMethod.POST, RuleMethods.COUNT, query);
  }

  public getNames(filter: Filter): Promise<string[]> {
    return this.httpClient.execute(HttpMethod.GET, RuleMethods.GET_NAMES, undefined, { filter });
  }

  public bulkAction(ids: string[], type: ActionType): Promise<{ id: string; error: any }[]> {
    const payload = { ids, type };
    return this.httpClient.execute(HttpMethod.POST, RuleMethods.BULK_ACTION, payload);
  }

  public findByNames(ruleNames: string[]): Promise<RuleJsonModel[]> {
    return this.httpClient.execute(HttpMethod.POST, RuleMethods.FIND_BY_NAMES, { ruleNames });
  }
}

export default NestRuleClient;
